<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.payments', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create_multiple_payments'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <div class="md:grid md:grid-cols-3 md:gap-6">
                <div class="mt-5 md:mt-0 md:col-span-1">
                    <div class="">
                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.date')" for="paid_at">
                                    <span v-if="!form.paid_at">
                                        <button @click="setDateToToday()" class="text-xs text-indigo-400" type="button">
                                            {{ $t('messages.today?') }}
                                        </button>
                                    </span>
                                </FormLabel>
                                <FormInput
                                    required
                                    id="paid_at"
                                    v-model="form.paid_at"
                                    name="paid_at"
                                    type="date"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.paid_at" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.type')" for="select_id" />
                                <FormSelect
                                    required
                                    id="select_id"
                                    v-model="form.select_id"
                                    :options="options.selects"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.select_id" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.quantity')" for="amount" />
                                <FormInput
                                    required
                                    id="amount"
                                    v-model="form.amount"
                                    name="amount"
                                    type="number"
                                    class="mt-1 w-full"
                                    step="0.01"
                                />
                                <FormError :value="form.errors.amount" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$tc('messages.scholarships', 1)" for="scholarship_id" />
                                <FormSelect
                                    id="scholarship_id"
                                    v-model="form.scholarship_id"
                                    :options="options.scholarships"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.scholarship_id" class="mt-2" />
                            </div>
                        </div>

                        <div class="">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.comment')" for="comment">
                                    <template v-slot:corner>
                                        <CharCounter
                                            :value="form.comment"
                                            :max="180"
                                            show-max
                                            class="text-sm font-medium leading-5 text-gray-500"
                                        />
                                    </template>
                                </FormLabel>
                                <FormTextarea
                                    id="comment"
                                    v-model="form.comment"
                                    name="comment"
                                    maxlength="180"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.comment" class="mt-2" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 md:mt-0 bg-gray-50 md:col-span-2">
                    <StudentBatchSelector :groups="groups" v-model="form.student_ids" />
                </div>
            </div>

            <div class="flex justify-end mt-5 space-x-2">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import AppButton from '@/components/AppButton.vue';
import CharCounter from '@/components/Forms/CharCounter.vue';
import StudentBatchSelector from '@/components/pageSpecific/StudentBatchSelector.vue';

export default {
    components: {
        PanelPage,
        FormInput,
        FormSelect,
        FormLabel,
        CharCounter,
        FormTextarea,
        FormError,
        AppButton,
        StudentBatchSelector,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'groups', 'defaults'],
    data() {
        return {
            form: this.$inertia.form({
                student_ids: [],
                amount: null,
                paid_at: new Date().toISOString().slice(0, 10),
                scholarship_id: null,
                select_id: null,
                comment: null,
            }),
            another: false,
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
        setDateToToday() {
            this.form.paid_at = new Date().toISOString().slice(0, 10);
        },
    },
};
</script>
